import { isJsObject, isAnyString, isFunction } from "./utils";

export function entryHasId(entry: any, validId=false) {
  return isJsObject(entry) && entry.hasOwnProperty('id') &&(!validId || (validId && entry.id));
}

export function tryNoDecimals(val: any) {
  if (Number.isFinite(val)) {
    var r2 = val.toFixed(2),
      r0 = val.toFixed(0);
    return (Math.abs(val - parseInt(r0, 10)) < 0.005) ? r0 : r2;
  }
  return val;
}

export function emailIsValid(email: string) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export function selectOptionById(option: any, selected: any) {
  return isJsObject(option) && isJsObject(selected) &&
    option.id == selected.id;
}

export function validateLength(value: any, length: any) {
  if (Number.isFinite(length) && length > 0) {
    if (Number.isFinite(value)) {
      value = '' + value;
    }
    if (isAnyString(value)) {
      return value.length < length;
    }
  }
  return true;
}

export function preventDefault($event: any) {
  isJsObject($event) && isFunction($event.preventDefault) &&
    $event.preventDefault();
}

export function stopPropagation($event: any) {
  isJsObject($event) && isFunction($event.stopPropagation) &&
    $event.stopPropagation();
}

export function stopAndPrevent($event: any) {
  if (isJsObject($event)) {
    isFunction($event.preventDefault) && $event.preventDefault();
    isFunction($event.stopPropagation) && $event.stopPropagation();
  }
}
